import { render, staticRenderFns } from "./RecommendList.vue?vue&type=template&id=b3bbeeea&"
import script from "./RecommendList.vue?vue&type=script&lang=js&"
export * from "./RecommendList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/hanmail/src/cafe-top/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b3bbeeea', component.options)
    } else {
      api.reload('b3bbeeea', component.options)
    }
    module.hot.accept("./RecommendList.vue?vue&type=template&id=b3bbeeea&", function () {
      api.rerender('b3bbeeea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/home/RecommendList.vue"
export default component.exports